import { render, staticRenderFns } from "./CorporatePricing.vue?vue&type=template&id=2f8f8290"
import script from "./CorporatePricing.vue?vue&type=script&lang=js"
export * from "./CorporatePricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports